import React from 'react'
import { Platform, StyleSheet, Text, View } from 'react-native'
import { useSelector, useDispatch } from 'react-redux'

import styles, { colors, hexColorToRGBa } from '../styles/global'
import Button from '../UIControls/Button'
import { setShowProjectDontExistInInvitationModal } from '../../redux/actions'
import { applyPopoverWidth } from '../../utils/HelperFunctions'
import { translate } from '../../i18n/TranslationService'
import { fixedModalOverlayStyle } from '../../utils/fixedModalPosition'
import { useFixedModalOverlayPadding } from '../../hooks/useSafeAreaOverlayPadding'

export default function ProjectDontExistInInvitationModal() {
    const safeAreaOverlayPadding = useFixedModalOverlayPadding()
    const dispatch = useDispatch()

    const closeModal = () => {
        dispatch(setShowProjectDontExistInInvitationModal(false))
    }

    return (
        <View style={[localStyles.container, safeAreaOverlayPadding]}>
            <View style={[localStyles.popup, applyPopoverWidth()]}>
                <View style={localStyles.header}>
                    <Text style={localStyles.title}>{translate('Invitation to project')}</Text>
                    <Text style={localStyles.description}>{translate('Looks like this project does not exist')}</Text>
                </View>
                <View style={{ flexDirection: 'row', flex: 0 }}>
                    <Button title={'Ok'} type={'primary'} onPress={closeModal} />
                </View>
            </View>
        </View>
    )
}

const localStyles = StyleSheet.create({
    container: {
        position: 'absolute',
        zIndex: 10000,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: hexColorToRGBa(colors.Text03, 0.24),
        justifyContent: 'center',
        alignItems: 'center',
        ...Platform.select({ web: fixedModalOverlayStyle }),
    },
    popup: {
        backgroundColor: colors.Secondary400,
        padding: 16,
        boxShadow: '0px 16px 24px rgba(0,0,0,0.04)',
        borderRadius: 4,
        alignItems: 'center',
    },
    header: {
        marginBottom: 20,
        width: '100%',
    },
    title: {
        ...styles.title7,
        color: '#ffffff',
    },
    description: {
        ...styles.body2,
        color: colors.Text03,
    },
})
